// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Iqegp","label":"styles_label__HEKix","icon":"styles_icon__sQD2_"};